import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-orm';
import { APTerm } from '../builders/ap_term_builder';
import { IAPCoursesDatasource } from '../datasources/ap_courses_datasource';
import { IAPPlannedCourseDataSource } from '../datasources/ap_planned_course_datasource';
import { IAPPlannedCourseGroupDatasource } from '../datasources/ap_planned_course_group_datasource';
import { IAPProgramSlotDatasource } from '../datasources/ap_program_slot_datasource';
import { IAPSectionTypeDatasource } from '../datasources/ap_section_type_datasource';
import { IAPTermSlotGroupDatasource } from '../datasources/ap_term_slot_group_datasource';
import { IAPTermsDatasource } from '../datasources/ap_terms_datasource';
import { IAPYearSlotGroupDatasource } from '../datasources/ap_year_slot_group_datasource';
import { APModel } from '../models/ap_model';
import { APTermServant } from '../servants/ap_term_servant';
import { FeedbackSuggestedPlanModel } from './../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
angular
  .module('capability-ng-academic-planner')
  .factory(
    'updatePlanDataHelper',
    (
      ngAPCoursesDatasource: IAPCoursesDatasource,
      ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
      ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
      ngAPTermsDatasource: IAPTermsDatasource,
      ngAPTermSlotGroupDatasource: IAPTermSlotGroupDatasource,
      ngAPYearSlotGroupDatasource: IAPYearSlotGroupDatasource,
      ngAPSectionTypeDatasource: IAPSectionTypeDatasource,
      ngAPPlannedCourseGroupDatasource: IAPPlannedCourseGroupDatasource,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      ngAPModel: APModel
    ) => {
      return (response: any) => {
        const termsWithPriorityRegData = APTermServant.getTermsWithPriorityRegistrationDatesAssigned(
          response.data.term,
          response.data.priority_reg_slot
        );
        ngAPTermsDatasource.clear().write(termsWithPriorityRegData);
        ngAPTermSlotGroupDatasource.clear().write(response.data.term_slot_group);
        ngAPCoursesDatasource.clear().write(response.data.course);
        ngAPPlannedCoursesDatasource.clear().write(response.data.planned_course);
        ngAPPlannedCourseGroupDatasource.clear().write(response.data.planned_course_group);

        ngAPProgramSlotDatasource.clear().write(response.data.program_slot);
        ngAPYearSlotGroupDatasource.clear().write(response.data.year_slot_group);
        if (response.data.suggested_plan) {
          const previous_status = _4.get(ngFeedbackSuggestedPlanModel.read(), 'previous_status', '');
          ngFeedbackSuggestedPlanModel.clear().write({ ...response.data.suggested_plan, previous_status });
        }
        ngAPModel.clear().write({
          program: response.data.program,
          planned_term: response.data.planned_term
        });
        ngAPSectionTypeDatasource.clear().write(response.data.section_type);

        ORMMediator.run(ngAPTermsDatasource);
        return;
      };
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/helpers/update_plan_data_helper.ts